import BaseService from "@/http/baseService";
import DataPreparation from "@/libs/dataPreparation";

export default class ContactRequestService {
  static getRequests(payload) {
    const url = DataPreparation.apply(payload, '/contact-requests')
    return BaseService.getInstance().getData(url)
  }
}